import { React, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import { TrendingDown, TrendingUp } from 'react-feather';

const GoldPriceForm = ({ data }) => {
  const isPositiveChange = data?.price?.change?.compare_previous >= 0;
  const [goldPrice, setGoldprice] = useState(false);
  const [reload, setReload] = useState(false);
  useEffect(() => {
    try {
      axios.get('https://psu-thaigold.eappsoft.net/latest').then((res) => {
        setGoldprice(res.data?.response);
      });
    } catch (error) {
      console.error('Error', error?.message);
    }
    return () => {};
  }, [reload]);
  return (
    <div className="max-w-md mx-auto p-1 bg-gradient-to-br from-yellow-300 via-yellow-500 to-yellow-600 rounded-2xl shadow-xl ">
      <div className="bg-gradient-to-b from-yellow-50 to-white rounded-2xl overflow-hidden">
        {/* Header Section */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400 opacity-90" />
          <div className="relative p-6">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-xl font-bold text-yellow-900 lg:text-2xl ">
                ราคาทองคำ
              </h1>
              <div className="px-3 py-1 bg-white bg-opacity-90 rounded-full shadow-sm">
                <span className="text-sm text-yellow-800">
                  {goldPrice?.date}
                </span>
              </div>
            </div>

            {/* Main Price Display */}
            <div className="bg-white bg-opacity-90 p-4 rounded-xl shadow-lg">
              <div className=" text-xl font-bold text-yellow-800 mb-2 lg:text-2xl  xl:text-3xl">
                {goldPrice?.price?.gold?.buy} บาท
              </div>
              {/* <div className="flex items-center gap-2">
                <span className="px-4 py-1 bg-blue-500 text-white text-sm font-medium rounded-full">
                  <div className="flex">
                    {isPositiveChange ? (
                      <TrendingUp size={20} />
                    ) : (
                      <TrendingDown size={20} />
                    )}
                    <div className="pl-2">
                      {goldPrice?.price?.change?.compare_previous}
                    </div>
                  </div>
                </span>
              </div> */}
              <p className="text-sm text-center text-gray-600">
                อัพเดทล่าสุด: {goldPrice?.update_time}
              </p>
            </div>
          </div>
        </div>

        {/* Price Details */}
        <div className="p-6 space-y-6">
          {/* ทองคำแท่ง */}
          <div className="bg-gradient-to-r from-yellow-50 to-white p-4 rounded-xl border border-yellow-300 shadow-sm">
            <h2 className="text-lg font-semibold text-yellow-800 mb-3">
              ทองรูปพรรณ 96.5%
            </h2>
            <div className="lg:grid grid-cols-2 gap-4">
              <div className="p-3 bg-white rounded-lg border border-yellow-300">
                <span className="text-sm text-yellow-600 block mb-1">
                  ราคาขาย
                </span>
                <span className="text-xl font-bold text-yellow-900">
                  {goldPrice?.price?.gold?.buy}
                </span>
              </div>
              <div className="p-3 bg-white rounded-lg border border-yellow-300">
                <span className="text-sm text-yellow-600 block mb-1">
                  ราคารับซื้อ
                </span>
                <span className="text-xl font-bold text-yellow-900">
                  {goldPrice.price?.gold?.sell}
                </span>
              </div>
            </div>
          </div>

          {/* ทองรูปพรรณ */}
          <div className="bg-gradient-to-r from-yellow-50 to-white p-4 rounded-xl border border-yellow-300 shadow-sm">
            <h2 className="text-lg font-semibold text-yellow-800 mb-3">
              ทองคำแท่ง 96.5%
            </h2>
            <div className="lg:grid grid-cols-2 gap-4">
              <div className="p-3 bg-white rounded-lg border border-yellow-300">
                <span className="text-sm text-yellow-600 block mb-1">
                  ราคาขาย
                </span>
                <span className="lg:text-xl font-bold text-yellow-900">
                  {goldPrice?.price?.gold_bar.buy}
                </span>
              </div>
              <div className="p-3 bg-white rounded-lg border border-yellow-300">
                <span className="text-sm text-yellow-600 block mb-1">
                  ราคารับซื้อ
                </span>
                <span className="text-xl font-bold text-yellow-900">
                  {goldPrice?.price?.gold_bar.sell}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="p-4 border-t border-yellow-100"></div>
      </div>
    </div>
  );
};

export default GoldPriceForm;
